import { useValidatePromoCodeForm } from "./useValidatePromoCodeForm";
import { FormProvider } from "react-hook-form";
import { styled } from "styled-system/jsx";
import { PromoCodeInput } from "./PromoCodeInput";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCartContext } from "widgets/booker/contexts";

export const ValidatePromoCodeForm = () => {
  const [status, setStatus] = useState<
    "neutral" | "error" | "notApplicable" | "success"
  >("neutral");

  const { form, onSubmit } = useValidatePromoCodeForm({
    onSuccess: () => setStatus("success"),
    onError: isNotApplicable =>
      setStatus(isNotApplicable ? "notApplicable" : "error"),
  });

  // Surfaces the case where an already-applied promo code was cleared
  // automatically because a tier change made it no longer apply.
  const { promoCodeError } = useCartContext();
  useEffect(() => {
    if (promoCodeError) setStatus("notApplicable");
  }, [promoCodeError]);

  const { t } = useTranslation("booker", { keyPrefix: "CHECKOUT.PROMO_CODE" });

  const getFormValidationMessage = () => {
    switch (status) {
      case "success":
        return t("SUCCESS");
      case "error":
        return t("ERROR");
      case "notApplicable":
        return t("NOT_APPLICABLE");
      case "neutral":
        return null;
    }
  };

  return (
    <FormProvider {...form}>
      <styled.form onSubmit={onSubmit} width={"full"}>
        <PromoCodeInput
          formValidationMessage={getFormValidationMessage()}
          isValidationError={status === "error" || status === "notApplicable"}
        />
      </styled.form>
    </FormProvider>
  );
};
